/* TolMol Deals — <tm-viewers>
   Nudges the viewer count by one every few seconds so it feels live rather
   than frozen. Server-rendered value is the starting point, so the first
   paint matches for everyone; drift is client-side only. Pauses when the
   tab is hidden, and honours prefers-reduced-motion by staying still. */

class TMViewers extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-tm-viewers]');
    if (!this.output) return;

    this.min = parseInt(this.dataset.min, 10) || 2;
    this.max = parseInt(this.dataset.max, 10) || 40;
    if (this.max < this.min) this.max = this.min;

    this.value = parseInt(this.output.textContent, 10) || this.min;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.onVisibility = () => (document.hidden ? this.stop() : this.schedule());
    document.addEventListener('visibilitychange', this.onVisibility);
    this.schedule();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  schedule() {
    this.stop();
    // 5–13s, so the cadence never looks metronomic
    this.timer = window.setTimeout(() => this.tick(), 5000 + Math.random() * 8000);
  }

  tick() {
    let next = this.value + (Math.random() < 0.5 ? -1 : 1);
    if (next < this.min) next = this.min + 1;
    if (next > this.max) next = this.max - 1;
    if (next !== this.value) {
      this.value = next;
      this.output.textContent = next;
    }
    this.schedule();
  }

  stop() {
    if (this.timer) window.clearTimeout(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('tm-viewers')) {
  customElements.define('tm-viewers', TMViewers);
}
